import React, { FC, memo } from 'react';
import classNames from 'classnames';
import Checkbox from '../Checkbox';
import classes from './styles/index.module.scss';
import { isNullOrUndefined } from '../../predicates/type';
import { EMPTY_FUNCTION } from './const';
import { CheckboxItem, OnIndicatorToggleHandler } from './types';

export type CheckboxGroupProps = {
	items?: CheckboxItem[];
	arrangement?: 'horizontally' | 'vertically';
	labelClassName?: string;
	className?: string;
	listItemClassName?: string;
	onIndicatorToggle?: OnIndicatorToggleHandler;
	componentLabelLight?: boolean;
	componentLabelCentered?: boolean;
	alignStart?: boolean;
};

const DEFAULT_ITEMS = [];

export const CheckboxGroup: FC<React.PropsWithChildren<CheckboxGroupProps>> = memo(
	({
		className,
		items = DEFAULT_ITEMS,
		componentLabelLight,
		componentLabelCentered,
		listItemClassName = '',
		labelClassName = '',
		arrangement = 'horizontally',
		onIndicatorToggle = EMPTY_FUNCTION,
		alignStart,
	}) => {
		const componentClasses = classNames(
			classes.checkboxList,
			{
				[classes.checkboxList_horizontal]: arrangement === 'horizontally',
				[classes.checkboxList_vertical]: arrangement === 'vertically',
				[classes.checkboxList_alignStart]: alignStart,
			},
			className,
		);

		const listItemClasses = classNames(classes.listItem, listItemClassName);

		return (
			<div
				data-testid='checkbox-group'
				className={componentClasses}
			>
				{items.map((checkbox) => {
					const { id, label, checked, children } = checkbox;

					const hasChildren = !isNullOrUndefined(children);

					return (
						<div
							className={listItemClasses}
							key={id}
						>
							<Checkbox
								checked={checked}
								label={label}
								labelClassName={labelClassName}
								onChange={(isChecked) => {
									onIndicatorToggle(id, isChecked);
								}}
								labelLight={componentLabelLight}
								labelCentered={componentLabelCentered}
							></Checkbox>
							{hasChildren && children}
						</div>
					);
				})}
			</div>
		);
	},
);

CheckboxGroup.displayName = 'CheckboxGroup';
